// vendors
import React from 'react';
import { i18n } from 'core/i18n'
const { FormattedText, formatText } = i18n;
// components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
import { OKCheckbox } from 'commonsComponents/OKCheckbox';
import { OKLink } from 'commonsComponents/OKLink';
// constants
import { WELCOME_PAYROLL_ACCOUNT_PRECONTRACTUAL_LINK } from 'constants/index';

const HireWelcomeAccountLegalCheckbox = ({
    checkboxError,
    checkboxErrorMessage,
    checkboxValue,
    contractName,
    hasBeenEmailSent,
    immHireWelcomeAccount,
    offerAccountData,
    onCheckboxChange,
    setTermsAndCondsText,
    welcomeAccountPayroll
}) => {

    const buildPayrollCheckboxLabel = () => {
        const contractualInfoLink = welcomeAccountPayroll ? WELCOME_PAYROLL_ACCOUNT_PRECONTRACTUAL_LINK : formatText('hireWelcomeAccount-hireWelcomeAccount_precontractualLink');
        const productLink = formatText('hireWelcomeAccount-hireWelcomeAccount_productLink');
        const contractualInfoLabel = <FormattedText value="hireWelcomeAccount-hireWelcomeAccount_contractualInfoLabel" />;
        const productLabel = <FormattedText value="hireWelcomeAccount-hireWelcomeAccount_productLabel" />;
        const contractualInfoComponent = (
            <OKLink modifier="emphasize" to={contractualInfoLink} target="_blank">
                {contractualInfoLabel}
            </OKLink>
        );
        const productComponent = (
            <OKLink modifier="emphasize" to={productLink} target="_blank">
                {productLabel}
            </OKLink>
        );
        const termsAndCondsText = formatText('hireWelcomeAccount-hireWelcomeAccount_precontractualMailCheckbox',
            [formatText('hireWelcomeAccount-hireWelcomeAccount_contractualInfoLabel'),
            formatText('hireWelcomeAccount-hireWelcomeAccount_productLabel')]
        );

        setTermsAndCondsText(termsAndCondsText);

        return (
            <FormattedTextWithComponents
                value="hireWelcomeAccount-hireWelcomeAccount_precontractualMailCheckbox"
                injectedComponents={[
                    contractualInfoComponent,
                    productComponent
                ]}
            />
        )
    }

    const buildCheckboxLabel = () => {
        const commisionsDocLink = offerAccountData && offerAccountData.getIn(['accountConfig', 'precontractualDicUrl']);
        const preContractualDocLink = immHireWelcomeAccount.getIn(['precontractualDocument', 'url']);
        const text = formatText('hireWelcomeAccount-hireWelcomeAccount_precontractualMailCheckboxBDE', [preContractualDocLink, commisionsDocLink]);
        setTermsAndCondsText(text);
        return <FormattedText value="hireWelcomeAccount-hireWelcomeAccount_precontractualMailCheckboxBDE" injectedStrings={[preContractualDocLink, commisionsDocLink]} />
    }


    const checkboxLabel = welcomeAccountPayroll ? buildPayrollCheckboxLabel() : buildCheckboxLabel();
    return (
        <OKCheckbox
            key={contractName}
            idName={contractName}
            value={checkboxValue}
            onChange={onCheckboxChange}
            label={checkboxLabel}
            errorState={checkboxError}
            errorMessage={checkboxErrorMessage}
            disabled={hasBeenEmailSent}
        />
    );
};

export default HireWelcomeAccountLegalCheckbox;
